import './TitleBar.scss';
import { ArchiveButton } from './ArchiveButton';
import { COPY_SPECIFIC } from '@sonar-software/sonar-ts-constants';
import { coreActions } from '@sonar-software/sonar-core';
import { EditOutlined } from '@ant-design/icons';
import { SonarText } from '@ui/text';
import { When } from 'react-if';
import { Button, Row, Space } from 'antd';
import React, { useCallback, useState } from 'react';
import { useAction, useCurrentUser } from '@hooks';
export const InitiativeTitleBar = ({ initiativeId, title }) => {
    const { isReadOnly } = useCurrentUser();
    const [isEditing, setIsEditing] = useState(false);
    const patchInitiative = useAction(coreActions.requestPatchCoreInitiativesById);
    const handleCancel = useCallback(() => {
        setIsEditing(false);
    }, []);
    const handleEditClick = useCallback(() => {
        setIsEditing(true);
    }, []);
    const handleChange = useCallback((updatedTitle) => {
        if (updatedTitle !== title) {
            patchInitiative({
                initiativeId: initiativeId,
                patchInitiativeDescription: {
                    title: updatedTitle
                }
            });
        }
        setIsEditing(false);
    }, [initiativeId, patchInitiative, title]);
    return (React.createElement(Row, { align: 'middle', className: 'initiative-title-bar', justify: 'space-between', wrap: false },
        React.createElement(SonarText, { className: 'title h1', editable: {
                editing: isEditing,
                icon: React.createElement("div", null),
                maxLength: 60,
                onCancel: handleCancel,
                onChange: handleChange,
                tooltip: false
            }, ellipsis: true }, title),
        React.createElement(When, { condition: !isEditing && !isReadOnly },
            React.createElement("div", { className: 'actions' },
                React.createElement(Space, null,
                    React.createElement(ArchiveButton, { initiativeId: initiativeId }),
                    React.createElement(Button, { icon: React.createElement(EditOutlined, null), id: 'initiative-rename-button', onClick: handleEditClick }, COPY_SPECIFIC.RENAME))))));
};
